// @flow
import type { IdealistDayEvent as ApiIdealistDayEvent } from 'api/groupAdmin';
import type { Volop as ApiVolop } from 'api/volopsAdmin';
import type { Action } from '../../actions/groupDashboard/listings';

export type Listing = {
  ...$Exact<ApiVolop | ApiIdealistDayEvent>,
  isFetching: boolean
};

export type State = {
  byId: {
    [string]: Listing
  }
};

const initialState = {
  byId: {}
};

export default function listings(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'GROUP_DASHBOARD_FETCH_LISTING_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listingId]: {
            ...state.byId[action.listingId],
            id: action.listingId,
            isFetching: true
          }
        }
      };
    case 'GROUP_DASHBOARD_FETCH_LISTING_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listing.id]: {
            ...action.listing,
            isFetching: false
          }
        }
      };
    case 'GROUP_DASHBOARD_RESET_LISTING':
      return initialState;
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
